import { render } from "./SubStatusEdit.vue?vue&type=template&id=4be8ee96"
import script from "./SubStatusEdit.vue?vue&type=script&lang=js"
export * from "./SubStatusEdit.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__